import React, { useContext } from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import { MediaSrcFile } from '../../../utils/DeviationMediaService/types';
import cleanLinkSrc from '../../../utils/xss/cleanLinkSrc';
import LazyContext from '../../../LazyLoadingImage/LazyContext';

export interface ImgProps {
  file: MediaSrcFile;
  deviation: PapiDeviation;
  imgStyles: {};
}

const Img: React.FC<ImgProps> = props => {
  const { file, deviation, imgStyles } = props;
  const enableLazyLoading = useContext(LazyContext);
  const isLazyLoaded = enableLazyLoading;
  return (
    <img
      loading={isLazyLoaded ? 'lazy' : undefined}
      src={cleanLinkSrc(file.src)}
      srcSet={file.srcSet}
      alt={deviation.title}
      style={imgStyles}
    />
  );
};
Img.displayName = 'Img';

export default Img;
